import { useTranslation } from 'react-i18next';

const comparisons = [
  { feature: 'comparison_org', spreadsheet: 'comparison_org_high', manual: 'comparison_org_low', highlight: 'spreadsheet' },
  { feature: 'comparison_filters', spreadsheet: 'comparison_yes', manual: 'comparison_no', highlight: 'spreadsheet' },
  { feature: 'comparison_compare', spreadsheet: 'comparison_easy', manual: 'comparison_hard', highlight: 'spreadsheet' },
  { feature: 'comparison_seller', spreadsheet: 'comparison_seller_easy', manual: 'comparison_seller_slow', highlight: 'spreadsheet' },
  { feature: 'comparison_discovery', spreadsheet: 'comparison_discovery_high', manual: 'comparison_discovery_med', highlight: 'spreadsheet' },
];

export default function Comparison() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-4">
            {t('comparison_title')}
          </h2>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse rounded-2xl overflow-hidden shadow-sm border border-background-200">
            <thead>
              <tr className="bg-foreground-900">
                <th className="px-6 py-4 text-left text-sm font-semibold text-white uppercase tracking-wider">
                  {t('comparison_header_feature')}
                </th>
                <th className="px-6 py-4 text-center text-sm font-semibold text-primary-300 uppercase tracking-wider">
                  {t('comparison_header_spreadsheet')}
                </th>
                <th className="px-6 py-4 text-center text-sm font-semibold text-white/70 uppercase tracking-wider">
                  {t('comparison_header_manual')}
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisons.map((row, index) => (
                <tr
                  key={row.feature}
                  className={`border-b border-background-200 ${index % 2 === 0 ? 'bg-background-50' : 'bg-white'} hover:bg-primary-50/50 transition-colors`}
                >
                  <td className="px-6 py-4 text-sm font-medium text-foreground-900">
                    {t(row.feature)}
                  </td>
                  <td className="px-6 py-4 text-center text-sm font-semibold text-secondary-600">
                    {t(row.spreadsheet)}
                  </td>
                  <td className="px-6 py-4 text-center text-sm text-foreground-500">
                    {t(row.manual)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}